import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { MDBTableHead, MDBTable, MDBTableBody } from "mdbreact";
import { Loader } from "../../../UI/Loaders/Loaders";
import { appInsights } from "../../../config/appInsights";
import Paginator from "../../Pagination/Pagination.component";
import CustomSelectDropdown from "../../CustomHTMLElements/CustomSelectDropdown";
import { showModal } from "../../../redux/actions/modal";
import { useGetBlackList } from "./hooks/useBlackList";

const BlackList = () => {
  const [query, setQuery] = useState({
    pageNumber: 1,
    pageSize: 10,
    startDate: "",
    endDate: "",
    phoneNumber: "",
    email: "",
    rcNumber: "",
    bvn: "",
    nin: "",
    customerType: "",
  });
  const [state, setState] = useState({
    pageNumber: 1,
    pageSize: 10,
    startDate: "",
    endDate: "",
  });

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    appInsights.trackPageView({
      name: "BlackList.tsx",
      isLoggedIn: true,
    });
  }, []);

  const {
    data: blackListResponse,
    isLoading,
    isError: error,
    refetch,
  } = useGetBlackList({
    params: {
      pageNumber: query.pageNumber,
      pageSize: query.pageSize,
      startDate: query.startDate,
      endDate: query.endDate,
      customerType: query.customerType,
      email: query.email,
      phoneNumber: query.phoneNumber,
      bvn: query.bvn,
      nin: query.nin,
      rcNumber: query.rcNumber,
    },
  });

  const blackListData = {
    data: blackListResponse?.data || [],
    totalCount: blackListResponse?.totalCount || 0,
  };

  let RenderedComponent = null;
  if (!blackListData && !isLoading) {
    RenderedComponent = (
      <div>
        <div className="grid__padding animated fadeInRight">
          <h4 className="center-txt">
            <i className="fas fa-bell" /> Unable to Fetch BlackList Records
          </h4>
        </div>
      </div>
    );
  } else if (isLoading) {
    RenderedComponent = (
      <Loader centered={true} text="Loading BlackList Records..." />
    );
  } else {
    if (error) {
      RenderedComponent = (
        <div>
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There was an issue while fetching
              BlackList Records, Please Reload The Page{" "}
            </h4>
          </div>
        </div>
      );
    } else if (
      (blackListData &&
        blackListData.data &&
        blackListData.data.length === 0) ||
      (blackListData && !blackListData.data)
    ) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt p-y-5">
              <i className="fas fa-bell" /> There are currently no BlackList
              Records
            </h4>
          </div>
        </div>
      );
    } else {
      RenderedComponent = (
        <>
          <MDBTable
            responsive
            minimal="true"
            striped={false}
            bordered
            hover
            id="table-to-xls"
          >
            <MDBTableHead>
              <tr>
                <th>S/N</th>
                <th>Customer Name</th>
                <th>Customer Type</th>
                <th>BVN/RC Number</th>
                <th>Email</th>
                <th>Phone Number</th>
                <th>Activation Reason</th>
                <th>Created By</th>
                <th>Created At</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </MDBTableHead>
            <MDBTableBody>
              {blackListData &&
                blackListData.data.map((data: any, _id: number) => {
                  const {
                    firstName,
                    lastName,
                    businessName,
                    customerType,
                    email,
                    phoneNumber,
                    bvn,
                    rcNumber,
                    activationReason,
                    createdByName,
                    createdAt,
                    isActive,
                  } = data;

                  // Determine customer name based on type
                  const customerName =
                    customerType === "Organisation"
                      ? businessName
                      : `${firstName || ""} ${lastName || ""}`.trim();

                  // Determine BVN or RC Number
                  const identifier =
                    customerType === "Organisation" ? rcNumber : bvn;

                  return (
                    <tr key={_id}>
                      <td>
                        {" "}
                        {(query?.pageNumber - 1) * query?.pageSize + (_id + 1)}
                      </td>
                      <td>{customerName || "N/A"}</td>
                      <td>{customerType}</td>
                      <td>{identifier || "N/A"}</td>
                      <td>{email}</td>
                      <td>{phoneNumber}</td>
                      <td>{activationReason || "N/A"}</td>
                      <td>{createdByName || "N/A"}</td>
                      <td>
                        {createdAt
                          ? moment(createdAt).format("DD-MM-YYYY")
                          : ""}
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            isActive ? "badge-success" : "badge-danger"
                          }`}
                        >
                          {isActive ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td>
                        <span
                          className="color-mid-blue cursor-pointer font-weight-bold"
                          onClick={() => {
                            dispatch(
                              showModal({
                                modalIdentifier: "viewblacklist",
                                dataRecord: data,
                              })
                            );
                          }}
                        >
                          {" "}
                          View Details
                        </span>
                      </td>
                    </tr>
                  );
                })}
            </MDBTableBody>
          </MDBTable>
        </>
      );
    }
  }

  const handleFilterChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = event.target;
    setState((prevParams) => ({
      ...prevParams,
      [name]: value,
    }));
  };

  const filterData = () => {
    setQuery({
      ...state,
      email: query.email,
      phoneNumber: query.phoneNumber,
      bvn: query.bvn,
      nin: query.nin,
      rcNumber: query.rcNumber,
      customerType: query.customerType,
    });
  };

  const handleClear = () => {
    setQuery({
      pageNumber: 1,
      pageSize: 10,
      startDate: "",
      endDate: "",
      phoneNumber: "",
      email: "",
      rcNumber: "",
      bvn: "",
      nin: "",
      customerType: "",
    });
    setState({
      pageNumber: 1,
      pageSize: 10,
      startDate: "",
      endDate: "",
    });
  };

  const handleCreateBlackList = () => {
    dispatch(
      showModal({
        modalIdentifier: "createblacklist",
        dataRecord: {
          refetch,
        },
      })
    );
  };

  const handleAdvancedSearch = () => {
    dispatch(
      showModal({
        modalIdentifier: "advancedblacklistsearch",
        dataRecord: {
          onSearch: (searchParams: any) => {
            setQuery((prev) => ({
              ...prev,
              pageNumber: 1,
              ...searchParams,
            }));
          },
        },
      })
    );
  };

  return (
    <div className="datatable-wrapper">
      <div className="table-view speed-1x animated fadeInRight">
        <div className="d-flex justify-content-between mb-4">
          <h3 className="page-title mb-0">Customer BlackList</h3>
          <button
            className="btn advancly-btn m-0"
            onClick={handleCreateBlackList}
          >
            <i className="fas fa-plus" />
            &nbsp; Create BlackList
          </button>
        </div>

        <div className="row">
          <div className="form-group col-md-2">
            <label>From</label>
            <div className="input-group">
              <input
                type="date"
                name="startDate"
                className="form-control"
                value={state.startDate}
                onChange={handleFilterChange}
              />
            </div>
          </div>
          <div className="form-group col-md-2">
            <label>To</label>
            <div className="input-group">
              <input
                type="date"
                className="form-control"
                name="endDate"
                value={state.endDate}
                onChange={handleFilterChange}
              />
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <CustomSelectDropdown
                name="pageSize"
                value={state.pageSize}
                onChange={handleFilterChange}
                isShowDropdownArrow
              >
                <option value={10}>10 Entries</option>
                <option value={20}>20 Entries</option>
                <option value={50}>50 Entries</option>
                <option value={100}>100 Entries</option>
              </CustomSelectDropdown>
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <button
                className="btn advancly-white-btn form-control"
                onClick={handleAdvancedSearch}
              >
                <i className="fas fa-search-plus" />
                &nbsp; Advanced Search
              </button>
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <button
                className="btn advancly-btn ml-2 form-control"
                onClick={filterData}
              >
                Search
              </button>
            </div>
          </div>
          <div className="form-group col-md-2" style={{ marginTop: "30px" }}>
            <div className="input-group">
              <button
                type="submit"
                className={`btn advancly-red-btn btn-md ml-3`}
                style={{ height: "3rem" }}
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
          </div>
        </div>

        <div>{RenderedComponent}</div>

        <Paginator
          size={query.pageSize}
          page={query.pageNumber}
          count={blackListData?.totalCount}
          changeCurrentPage={(pageNumber: number) =>
            setQuery({ ...query, pageNumber: pageNumber })
          }
        />
      </div>
    </div>
  );
};

export default BlackList;
